// extracted by mini-css-extract-plugin
module.exports = {"baseSize":"App_baseSize__2mwwr"};